import CreateTreeProductModal from "./CreateTreeProductModal";

export default CreateTreeProductModal;
